<template>
  <div class="row">
    <!-- <component-loader :progress="90" :unlimitedProgress="true" v-if="!list || showLoader"></component-loader> -->
    <div class="col left">
      <div class="header">
        <div class="title">
          {{ $t('dash.inbox.title.section') }}
        </div>
        <div class="cta">
          <div class="search">
            <div class="container-svg-serach">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#AB6E93"/>
                </svg>
            </div>
            <input v-model="textFilter" :placeholder="$t('dash.placeholder.search')">           
          </div>
          <div class="btn-filter" :class="[{active: filter.type.length < 6 || filter.status.length < 4 || !filter.flag || filter.affected_to.length || filter.evaluation.length < 4}]">
            <div class="action" @click.stop="toggleFilter()">
              <i class="fa-solid fa-bars-filter"></i>

               <div class="container-filter" v-if="showFilter" @click.stop="()=>{}" ref="filterInbox">
                <div class="filter">
                  <div class="container-dates">
                
                    <div class="dates" v-if="false">
                      <input type="date" name="filterInboxDateStart" v-model="filter.dateStart" :max="(new Date).toISOString().split('T')[0]">
                      à
                      <input type="date" name="filterInboxDateEnd" v-model="filter.dateEnd" :min="filter.dateStart ? filter.dateStart :''" :max="(new Date).toISOString().split('T')[0]">
                    </div>
                  </div>
                  <div class="column border">
                    <div class="category type">
                      <div class="title-category">
                        <Checkbox :id="'addAllTypeEvent'" :isChecked="filter.type.length > 0" :isLine="filter.type.length < 6" :add="() => selectAllFilter('type')" :remove="() => removeAllFilter('type')"></Checkbox>
                        <h5>{{ $t('dash.inbox.filter.type.all') }}</h5>
                      </div>
                      <div class="list">
                        <!-- <div class="choice" v-for="value in ['message','comment','mention','rating','post','reaction']" :key="value"> -->
                        <div class="choice" v-for="value in ['message','comment','mention','rating']" :key="value">
                            <Checkbox :id="'type-'+value" :isChecked="filter.type.includes(value)" :add="addOptionFilter" :remove="removeOptionFilter" ></Checkbox>
                            <p>{{ $t('dash.inbox.filter.type.'+value) }}</p>
                        </div> 
                      </div>
                    </div>
                  </div>
                  <div class="column border">
                    <div class="category status">
                      <div class="title-category">
                        <Checkbox :id="'addAllStatusEvent'" :isChecked="filter.status.length > 0 || filter.flag" :isLine="filter.status.length < 4 || !filter.flag" :add="() => selectAllFilter('status')" :remove="() => removeAllFilter('status')"></Checkbox>
                        <h5>{{ $t('dash.inbox.filter.status.all') }}</h5>
                      </div>
                      <div class="list">
                        <div class="choice">
                            <Checkbox :id="'status-flag'" :isChecked="filter.flag" :add="addOptionFilter" :remove="removeOptionFilter"></Checkbox>
                            <p>{{ $t('dash.inbox.filter.status.flag') }}</p>
                        </div> 
                        <div class="choice" v-for="value in ['waiting','treated','removed','hided']" :key="value">
                            <Checkbox :id="'status-'+value" :isChecked="filter.status.includes(getTranslateFilter(value))" :add="addOptionFilter" :remove="removeOptionFilter"></Checkbox>
                            <p>{{ $t('dash.inbox.filter.status.'+value) }}</p>
                        </div> 
                      </div>
                    </div>
                  </div> 


     
                  <div class="column">
                      <div class="category evaluation">
                        <div class="title-category">
                          <Checkbox :id="'addAllEvaluationEvent'" :isChecked="filter.evaluation.length > 0" :isLine="filter.evaluation.length < 4" :add="() => selectAllFilter('evaluation')" :remove="() => removeAllFilter('evaluation')"></Checkbox>
                          <h5>{{ $t('dash.inbox.filter.evaluation.all') }}</h5>
                        </div>
                        <div class="list">
                          <div class="choice" v-for="value in ['good','normal','bad','none']" :key="value">
                            <Checkbox :id="'evaluation-'+value" :isChecked="filter.evaluation.includes(getTranslateFilter(value))" :add="addOptionFilter" :remove="removeOptionFilter"></Checkbox>
                              <div class="badge-evaluation" :class="value ">{{ $t('dash.inbox.filter.evaluation.'+value) }}</div>
                          </div> 
                        </div>
                      </div>
                      <div class="category affected_to">
                        <div class="title-category">
                          <h5>{{ $t('dash.inbox.filter.affected_to.title') }}</h5>
                        </div>
                        <div class="list">
                          <img class="image-user" v-for="(user, key) in filter.affected_to.slice(0,2)" :key="key" :src="user.avatar && user.avatar.length ? user.avatar : require('../../../assets/img/ico-man.svg')">
                            
                        
                          <i class="fa-solid fa-user-plus" @click="popupSelectUsers = true"></i>

                          <vs-popup class="overlay groups shared-planner affected_to" :title="$t('dash.inbox.filter.affected_to.popup.title')" :active.sync="popupSelectUsers">
                            <component-users-selector v-if="popupSelectUsers" :usersAdded="filter.affected_to" v-on:submit="addAffectedToFilter"></component-users-selector>
                          </vs-popup>

                        </div>
                      </div>
                  </div>
                </div>
              </div>

            </div>
           
          </div>
          <div class="reload" @click="refresh()">
            <i class="fa-solid fa-rotate-right"></i>
          </div>
        </div>
      </div>
      <component-list-inbox 
        :page="page" 
        :pages="pages" 
        :list="list.filter(e => pages.find(p => e.network == p.network && e.page == p.network_id))"
        :totalEvents="totalEvents"
        :totalAllEvents="totalAllEvents"
        :selected="selected"
        :textFilter="textFilter"
        :isLoading="isLoading || mainLoading"
        :filter="filter"
        @select="selectEvent"
        @change="changeEvent"
        @changeMultiTask="changeMultiTask"
        @nextEvents="getInbox"
      ></component-list-inbox>
    </div>
    <div class="col right">
      <component-user-inbox 
        v-if="selected && selected.user"
        :user="selected.user"
        :page="pages.find(p => p.network_id == selected.page && p.network == selected.network)"
        @getActivities="getActivitiesUser"
        @refreshEvents="refresh"
      ></component-user-inbox>
      <component-detail-inbox 
        v-if="selected"
        :event="selected"
        :page="pages.find(p => p.network_id == selected.page && p.network == selected.network)"
        @change="changeEvent"
        @submitComment="submitComment"
        @submitLike="submitLike"
        @deleteComment="deleteComment"
        @hideComment="hideComment"
        @updateEventMissingInfos="updateEventMissingInfos"
      ></component-detail-inbox>
    </div>
  </div>

  
</template>

<script>
import moment from 'moment'
import Moderation from './../../mixins/Moderation'
import Settings from './../../mixins/Settings'
import Bots from './../../mixins/Bots'
import Tooltip from './../tooltip/tooltipInit'
import PageImageAvatar from './../PageImageAvatar'
import ComponentListInbox from './ListInbox'
import ComponentUserInbox from './UserInbox'
import ComponentDetailInbox from './DetailInbox'
import ClickOutside from 'vue-click-outside'
import componentUsersSelector from './../overlay/UsersSelector.vue'
import componentLoader from './../overlay/Loader'

import Queuer from '../../../utils/Queuer'
import Checkbox from './../utils/checkbox.vue'

const translateFilter = {
  waiting : 0,
  treated : 1,
  removed : 4,
  hided : 5,

  good : 3,
  normal : 2,
  bad : 1,
  none : 0,
}

export default {
  name: 'component-inbox',

  mixins: [Moderation, Settings, Bots],

  directives: {
    ClickOutside
  },

  components: {
    Tooltip,
    PageImageAvatar,
    ComponentListInbox,
    ComponentUserInbox,
    ComponentDetailInbox,
    componentUsersSelector,
    componentLoader,
    Checkbox
  },

  props: {
    page: Object,
    pages: Array
  },

  data() {
    return {
      initialInboxLoaded: false,
      from: {},
      mainFrom: 0,
      mainStop: false,
      mainLoading: false,
      showLoader: false,
      list: [],
      totalEvents: 0,
      totalAllEvents: 0,
      selected: null,
      filter: {
        userId: null,
        // type: ["message","comment","mention","rating","post","reaction"],
        type: ["message","comment","mention","rating"],
        status: [0,1,4,5],
        flag: true,
        evaluation: [0,1,2,3],
        affected_to: [],
        dateStart: null,
        dateEnd: null
      },
      textFilter: '',
      showFilter: false,
      popupSelectUsers: false,
      isLoading:false,
      filterIsModified:false,
    }
  },

  async mounted() {
    this.isLoading = true
    if(localStorage.inboxFilter && JSON.parse(localStorage.inboxFilter))
      this.filter = JSON.parse(localStorage.inboxFilter)
    if(!localStorage.users)
      this.getUsers()

    // Le premier chargement se fait via le watcher "pages" (immediate) juste en dessous,
    // pour ne jamais lancer getInbox() avant que la liste des pages soit vraiment prête -
    // sinon un second appel (déclenché par ce même watcher dès que les pages arrivent)
    // court-circuite le premier et son enrichissement en cours (avatars/noms non à jour
    // juste après un reload complet).
  },

   

  methods: {

    getUsers() {
      this.listUsers({}).then(res => {
        const { success, users } = res.body

        if (success !== true || 'error' in res.body) {
          return this.handleError(res)
        }

        this.users = users
        localStorage.setItem('users', JSON.stringify(this.users))
      }).catch(this.handleError)
    },

    addAffectedToFilter(users) {
      this.filter.affected_to = users
      this.popupSelectUsers = false
      this.filterIsModified = true
    },

    selectAllFilter(type) {
      console.log('selectAll', type, this.filter[type])
      if(this.filter[type].length == 0) {
        switch(type) {
          case 'type': 
            this.filter[type] = ["message","comment","mention","rating","post","reaction"]
            break
          case 'status': 
            this.filter[type] = [0, 1, 4,5]
            this.filter.flag = true
            break
          case 'evaluation': 
            this.filter[type] = [0, 1, 2, 3]
            break
        }   
      } else {
        this.filter[type] = []
        if(type == 'status')
          this.filter.flag = false
      }
      // this.$forceUpdate()
      this.filterIsModified = true
    },
    removeAllFilter(type) {
      this.filter[type] = []
      if(type == 'status') this.filter.flag = false
      // this.$forceUpdate()
      this.filterIsModified = true
    },

    addOptionFilter(typeAndOption) {
      let [type, option] = typeAndOption.split('-');
      if(type == 'status' && option == 'flag') {
        this.filter.flag = true
      }else if (type == 'type' && !this.filter[type].includes(option)){
        this.filter[type].push(option)
      }else if(!this.filter[type].includes(translateFilter[option])) {
        this.filter[type].push(translateFilter[option])
      }
      this.filterIsModified = true
    },

    removeOptionFilter(typeAndOption) {
      let [type, option] = typeAndOption.split('-');
      console.log("removeOptionFilter",type,option)
      if(type == 'status' && option == 'flag') {
        this.filter.flag = false
      }else if (type == 'type'){
        this.filter[type] = this.filter[type].filter(v => v !== option)
      }else {
        this.filter[type] = this.filter[type].filter(v => v !== translateFilter[option])
      }
      this.filterIsModified = true
    },

    getTranslateFilter(key) {
      return translateFilter[key]
    },

    toggleFilter() {
      this.showFilter ? this.closeFilter() : this.openFilter()
    },

    openFilter() {
      this.showFilter = true
      this.filterIsModified = false
      window.addEventListener('click', this.handleClickOutsideFilter);
    },

    async closeFilter() {
      this.showFilter = false
      window.removeEventListener("click", this.handleClickOutsideFilter);
      if (this.filterIsModified) {
        this.refresh()
        localStorage.setItem('inboxFilter', JSON.stringify(this.filter))
      }
      this.filterIsModified = false
    },

    handleClickOutsideFilter(event) {
        const targetElement = this.$refs.filterInbox;
        if (!targetElement.contains(event.target) && !this.popupSelectUsers) {
            this.closeFilter() 
        }
    },
   


    async deleteComment(originId, commentId) {

      let event = this.list.find(l => l._id == originId)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      await this.deleteNode(page, commentId)
      if(this.selected.network == 'instagram' && this.selected.data.changes.value.id == commentId)
        await this.changeEvent(originId, { status: 4 })
      if(this.selected.addedComments && this.selected.addedComments.length && this.selected.addedComments.find(c => c.id == commentId)) {
        let addedComments = this.selected.addedComments.filter(c => c.id != commentId)
        await this.changeEvent(originId, { addedComments })
      }
      else {
        this.list = this.list.filter(l => l._id != originId)
        this.selected = null
        this.$forceUpdate()
      }
    },

    async hideComment(event, commentId, is_hidden){

      this.showLoader = true

      // let event = this.list.find(l => l._id == originId)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      await this.hideNode(page, commentId, is_hidden)
      
      await this.changeEvent(event._id, { hide: !event.hide })
    },

    async submitComment(originId, nodeId, message) {
      this.showLoader = true

      let event = this.list.find(l => l._id == originId)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      let mediaId
      if(event.network == 'instagram' && event.type == 'mention') {
        mediaId = event.data.changes.value.media_id
        nodeId = event.data.changes.value.comment_id
      }
      
      this.addComment(page, nodeId, message, mediaId).then(async res => {
        this.showLoader = false
        const { success, comment } = res.body

        if (!success || success !== true) {
          return
        }
        
        let addedComments = []
        if(this.selected.addedComments && this.selected.addedComments.length)
        addedComments = this.selected.addedComments 
        addedComments.push({
          id: comment.id,
          message
        })
        
        await this.changeEvent(originId, { addedComments })

      })
    },

    async submitLike(originId, nodeId) {
      this.showLoader = true

      let event = this.list.find(l => l._id == originId)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      this.likeNode(page, nodeId).then(async res => {
        this.showLoader = false
        const { success, error } = res.body

        if (!success || success !== true) {
          return
        }

        addedReaction // like OR unlike 
        let addedReaction = 'like'
        if(this.selected.addedReaction && this.selected.addedReaction == 'like')
          addedReaction = 'unlike'
                
        await this.changeEvent(originId, { addedReaction })
      })
    },

    async changeEvent(id, body) {
      // this.showLoader = true

      let event = this.list.find(l => l._id == id)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      if(body && ['0','1'].includes(body.status) && this.selected)
        this.selected.status = parseInt(body.status)

      this.postInboxEvent(id, page, body).then(res => {
        console.log('resss', res)
        // this.showLoader = false
        const { success, error } = res.body

        if (!success || success !== true) {
          if(body && ['0','1'].includes(body.status) && this.selected)
            this.selected.status = body.status == '1' ? 0 : 1
          return
        }
        
        this.$set(this.list, this.list.findIndex(l => l._id == id), res.body.event)

        if(page.network == 'linkedin'){
          let reqId = event.data.generatedActivity
          let moreData
          if(event.data.decoratedSourcePost && event.data.decoratedSourcePost.entity)
            moreData = {post: event.data.decoratedSourcePost.entity}
          else if(event.data.decoratedGeneratedActivity && event.data.decoratedGeneratedActivity.comment)
            moreData = {post: event.data.decoratedGeneratedActivity.comment.object}
          this.updateEventMissingInfos(id, page, reqId, null, moreData)
        }

        if (!this.filter.status.includes(res.body.event.status)) {
          this.selected = this.list.find(event => this.filter.status.includes(event.status))
        }else {
          this.selected = res.body.event
        }
     
        // this.$forceUpdate()
        this.countRemainingEvents()
        if (body && body.status !== undefined)
          setTimeout(() => this.$emit('updateCountEvents', page.id), 1000)
      })
    },

    async changeMultiTask(body, all=false, ids=null) {
        this.showLoader = true
      this.postInboxEvents(this.pages, body, all ? this.filter : false, !all ? ids : null).then(async res => {
        console.log('resss', res)
        this.showLoader = false
        const { success, error } = res.body

        if (!success || success !== true) {
          return
        }

        // this.list = this.list.map(event => all || ids.includes(event._id) ? ({...event, ...body}) : (event))
        setTimeout(() => {
          this.refresh()
          this.$emit('updateCountEvents')
        }, 1000)
        // await this.getInbox()
        this.countRemainingEvents()
      })
    },
    
    selectEvent(event) {
      this.selected = event
      console.log('selected', this.selected)
    },

    async refresh() {


      if(this.filter.userId)
        this.filter.userId = null
      await this.getInbox({refresh: true})
    },

    async getActivitiesUser(user) {
      // this.filter.userId = userId
      this.filter = {
        userId: user.id,
        type: [],
        status: [],
        flag: null,
        evaluation: [],
        affected_to: []
      }
      await this.getInbox({refresh: true})
    },

    countRemainingEvents() {
      if(this.pages.length)
        this.countWaitingEvents(null, this.pages).then((res) => {
          console.log(res)
          if(res && res.body && res.body.pages) {
            this.totalEvents = res.body.pages.map(p => p.count).reduce((prev, curr) => prev + curr)
            this.$forceUpdate()
          }
        })
    },
    
    async getInbox(params = {forcePage: null, from: 0, refresh:false}){

      let {from, forcePage, refresh} = params

      if (from == 0 || this.list == [] || refresh) {
        this.showLoader = true
        this.isLoading = true
        this.list = []
        this.totalEvents = 0
        this.totalAllEvents = 0
        this.selected = null
        this.from = {}
        this.mainFrom = 0
        this.mainStop = false
        this.mainLoading = false
      }

      const sortComparator = (a, b) => {
        const da = a.date !== undefined ? a.date : (a._source ? a._source.date : 0) || 0
        const db = b.date !== undefined ? b.date : (b._source ? b._source.date : 0) || 0
        return db - da
      }

      // forcePage: page ajoutée dynamiquement (watcher pages), comportement per-page conservé
      if (forcePage) {
        const p = forcePage
        this.from[p.id] = this.from[p.id] && this.from[p.id].next >= 0
          ? {from: this.from[p.id].next, stop: this.from[p.id].stop, next: this.from[p.id].next}
          : {from: 0}
        this.$emit('updateLoadingPages', this.from)
        this.countRemainingEvents()
        if (this.from[p.id].stop) return

        if(this.list.length == 0) this.isLoading = true
        this.from[p.id].loading = 0

        if(p.network == 'linkedin' && p.story_config && p.story_config.created && this.from[p.id].from == 0 && !this.filter.userId) {
          this.from[p.id].loading += 1
          this.$emit('updateLoadingPages', this.from)
          this.listInboxEvents([p], 0, {...this.filter, asyncConversations: true}).then(res => {
            this.from[p.id].loading = this.from[p.id].loading ? this.from[p.id].loading - 1 : 0
            this.$emit('updateLoadingPages', this.from)
            const { success } = res.body
            if (!success || success !== true) { this.isLoading = false; return }
            let nextEvents = res.body.events.filter(e => !this.list.map(l => l._id).includes(e._id))
            this.list = this.list.concat(nextEvents)
            this.list = this.list.sort(sortComparator)
            this.enrichEvents(nextEvents)
          })
        }

        this.from[p.id].loading += 1
        this.$emit('updateLoadingPages', this.from)
        this.listInboxEvents([p], this.from[p.id].from, this.filter).then(res => {
          this.from[p.id].loading = this.from[p.id].loading ? this.from[p.id].loading - 1 : 0
          this.$emit('updateLoadingPages', this.from)
          const { success } = res.body
          if (!success || success !== true) { this.isLoading = false; return }

          let nextEvents = res.body.events.filter(e => !this.list.map(l => l._id).includes(e._id))
          this.list = this.list.concat(nextEvents)
          this.list = this.list.sort(sortComparator)
          this.enrichEvents(nextEvents)
          this.from[p.id].next = this.from[p.id].from + res.body.events.length
          this.from[p.id].stop = res.body.total == 0 || this.from[p.id].next >= res.body.total

          if(this.$route.params.object_id) {
            if(this.list.find(l => l.object_id == this.$route.params.object_id))
              this.selected = this.list.find(l => l.object_id == this.$route.params.object_id)
            else
              this.getInboxEvent(this.$route.params.moderation, this.$route.params.object_id).then((resEvent) => {
                this.list.push(resEvent.body.event)
                this.selected = resEvent.body.event
              })
            this.$route.params.moderation = null
            this.$route.params.object_id = null
          }
          this.totalAllEvents += res.body.total
          this.isLoading = false
          if(this.list.length && !this.selected) this.selected = this.list[0]
          this.catchUpMainPagination(this.mainFrom)
        })
        return
      }

      // === Requête combinée pour toutes les pages ===
      if (this.mainStop || this.mainLoading) return
      this.mainLoading = true

      for(let p of this.pages)
        this.from[p.id] = this.from[p.id] || {loading: 0, stop: false}
      this.$emit('updateLoadingPages', this.from)
      this.countRemainingEvents()

      const isPagination = this.list.length > 0

      // LinkedIn async conversations : une seule requête pour toutes les pages éligibles, chargement initial uniquement
      const linkedInAsyncPages = this.pages.filter(p =>
        p.network == 'linkedin' && p.story_config && p.story_config.created && !isPagination && !this.filter.userId
      )
      if (linkedInAsyncPages.length > 0) {
        linkedInAsyncPages.forEach(p => { this.from[p.id].loading = (this.from[p.id].loading || 0) + 1 })
        this.$emit('updateLoadingPages', this.from)
        this.listInboxEvents(linkedInAsyncPages, 0, {...this.filter, asyncConversations: true}).then(res => {
          linkedInAsyncPages.forEach(p => { this.from[p.id].loading = this.from[p.id].loading ? this.from[p.id].loading - 1 : 0 })
          this.$emit('updateLoadingPages', this.from)
          const { success } = res.body
          if (!success || success !== true) { this.isLoading = false; return }
          let nextEvents = res.body.events.filter(e => !this.list.map(l => l._id).includes(e._id))
          this.list = this.list.concat(nextEvents)
          this.list = this.list.sort(sortComparator)
          this.enrichEvents(nextEvents)
        })
      }

      // Requête principale : toutes les pages en une seule requête
      this.pages.forEach(p => { this.from[p.id].loading = (this.from[p.id].loading || 0) + 1 })
      this.$emit('updateLoadingPages', this.from)
      this.listInboxEvents(this.pages, this.mainFrom, this.filter).then(res => {
        this.pages.forEach(p => { this.from[p.id].loading = this.from[p.id].loading ? this.from[p.id].loading - 1 : 0 })
        this.$emit('updateLoadingPages', this.from)

        this.mainLoading = false
        const { success, error } = res.body
        if (!success || success !== true) {
          this.isLoading = false
          return
        }

        let nextEvents = res.body.events.filter(e => !this.list.map(l => l._id).includes(e._id))

        if (isPagination) {
          // Pagination : on ajoute en fin de liste sans re-trier, les nouveaux events n'apparaissent jamais au-dessus du scroll
          this.list = [...this.list, ...nextEvents.sort(sortComparator)]
        } else {
          this.list = this.list.concat(nextEvents)
          this.list = this.list.sort(sortComparator)
        }

        this.mainFrom += res.body.events.length
        // Page vide = fin de liste, sinon on relancerait le même from à chaque scroll
        this.mainStop = res.body.total == 0 || this.mainFrom >= res.body.total || !res.body.events.length
        this.pages.forEach(p => { this.from[p.id].stop = this.mainStop })

        if(this.$route.params.object_id) {
          if(this.list.find(l => l.object_id == this.$route.params.object_id))
            this.selected = this.list.find(l => l.object_id == this.$route.params.object_id)
          else
            this.getInboxEvent(this.$route.params.moderation, this.$route.params.object_id).then((resEvent) => {
              this.list.push(resEvent.body.event)
              this.selected = resEvent.body.event
            })

          this.$route.params.moderation = null
          this.$route.params.object_id = null
        }
        // total global de la requête, renvoyé identique à chaque page
        this.totalAllEvents = res.body.total
        this.isLoading = false

        if(this.list.length && !this.selected) this.selected = this.list[0]
        this.enrichEvents(nextEvents)

      })
    },

    // À appeler sur chaque lot ajouté à la liste : nextEvents est dédoublonné, chaque event n'est enrichi qu'une fois
    enrichEvents(events) {
      if(!events || !events.length) return
      let queue = new Queuer({
        data: JSON.parse(JSON.stringify(events)),
        task:(m) => {
          try {
            this.processMissingInfosTask(m, queue)
          } catch (e) {
            // Sans unlock() garanti ici (avant même l'appel réseau), une erreur sur un seul
            // event (ex: this.pages pas encore prêt juste après un reload complet) bloque
            // tout le reste du Queuer (group=1) - jamais traité, silencieusement.
            console.error('queue task setup failed for event', m._id, e)
            queue.unlock()
          }
        }
      })
      queue.init()
    },

    processMissingInfosTask(m, queue) {
              // let ind = this.list.findIndex(c => c._id == m._id)
              let page = this.pages.find(p => p.network_id == m.page && p.network == m.network)
              if(!page) {
                queue.unlock()
                return
              }
              // this.getEventMissingInfosFromRS(page.id, m.network == 'instagram' ? m.data.changes.value.comment_id || m.data.changes.value.media_id : m.userId).then((res) => {
              let type=null, reqId, moreData
              if(page.network == 'instagram') {
                if(m.type == 'mention') {
                  if(m.data.changes.value.comment_id) {
                    reqId = m.data.changes.value.comment_id
                    type = 'mention-comment'
                  }else if(m.data.changes.value.media_id) {
                    reqId = m.data.changes.value.media_id
                    type = 'mention-media'
                  }
                }
                else if(m.type == 'comment') {
                  // reqId = m.data.changes.value.media.id
                  reqId = m.data.changes.value.id
                  type = 'comment'
                }
                else if(m.type.includes('message')) {
                  // reqId = m.data.changes.value.media.id
                  reqId = m.data.messaging.sender.id != m.data.id ? m.data.messaging.sender.id : m.data.messaging.recipient.id
                  type = 'message'
                }
              } else if(page.network == 'linkedin') {
                reqId = m.data.generatedActivity
                moreData = {list: true}
                if(m.data.decoratedSourcePost && m.data.decoratedSourcePost.entity)
                  moreData = {...moreData, post: m.data.decoratedSourcePost.entity}
                else if(m.data.decoratedGeneratedActivity && m.data.decoratedGeneratedActivity.comment)
                  moreData = {...moreData, post: m.data.decoratedGeneratedActivity.comment.object}
                else if(m.data.detail && m.data.detail.comment)
                  moreData = {...moreData, post: m.data.detail.comment.object}
              } else {
                reqId = m.userId
              }
              console.log("getEventMissingInfosFromRS",page.id, reqId, type,m.type)
              if(page.network == 'linkedin' && m.type.includes('message')) {
                queue.unlock()
              }
              else {
                this.getEventMissingInfosFromRS(page.id, reqId, type, moreData).then((res) => {
                  try {
                    let ind = this.list.findIndex(c => c._id == m._id)
                    if(ind === -1) return

                    if(res && res.body && res.body.user) {
                      this.$set(this.list[ind], 'user', res.body.user)
                      this.$forceUpdate()
                    }
                    else if(res && res.body && res.body.detail) {
                      this.$set(this.list[ind], 'detail', res.body.detail)
                      if(page.network == 'linkedin') {
                        this.$set(this.list[ind], 'user', res.body.detail.user)
                      }
                      else {
                        if(res.body.detail.mentioned_comment) {
                          this.list[ind].user = res.body.detail.mentioned_comment.from
                          this.list[ind].data.changes.value.from = res.body.detail.mentioned_comment.from
                          this.list[ind].data.changes.value.text = res.body.detail.mentioned_comment.text

                        }else if(this.list[ind].data.changes.value.from) {
                          this.list[ind].user = this.list[ind].data.changes.value.from
                        }
                        else if(res.body.detail.mentioned_media) {
                          this.list[ind].user = {username: res.body.detail.mentioned_media.username}
                          this.list[ind].data.changes.value.from = {username: res.body.detail.mentioned_media.username}
                          this.list[ind].data.changes.value.text = res.body.detail.mentioned_media.caption
                          this.list[ind].data.changes.value.media_url = res.body.detail.mentioned_media.media_url
                        }
                      }
                      this.$forceUpdate()
                    }
                    else if(res && res.body && res.body.conversation && res.body.conversation.participants && res.body.conversation.participants.data) {
                      this.list[ind].user = res.body.conversation.participants.data.find(p => p.id == m.data.messaging.sender.id)
                    }
                  } catch (e) {
                    // Ne jamais laisser une erreur sur un event bloquer le Queuer (group=1) :
                    // sans unlock() garanti, tous les events suivants du batch ne seraient
                    // jamais traités.
                    console.error('updateEventMissingInfos (batch) failed for event', m._id, e)
                  } finally {
                    queue.unlock()
                  }
                })
              }
    },

    async catchUpMainPagination(targetFrom) {
      if (targetFrom <= 0 || this.mainStop) return
      const sortFn = (a, b) => {
        const da = a.date !== undefined ? a.date : (a._source ? a._source.date : 0) || 0
        const db = b.date !== undefined ? b.date : (b._source ? b._source.date : 0) || 0
        return db - da
      }
      this.mainFrom = 0
      try {
        while (this.mainFrom < targetFrom && !this.mainStop) {
          this.mainLoading = true
          const res = await this.listInboxEvents(this.pages, this.mainFrom, this.filter)
          if (!res.body || res.body.success !== true || !res.body.events || res.body.events.length === 0) break
          const newEvents = res.body.events.filter(e => !this.list.map(l => l._id).includes(e._id))
          if (newEvents.length) this.list = this.list.concat(newEvents).sort(sortFn)
          this.enrichEvents(newEvents)
          this.mainFrom += res.body.events.length
          this.mainStop = res.body.total == 0 || this.mainFrom >= res.body.total
        }
      } finally {
        this.mainLoading = false
      }
    },

    async updateEventMissingInfos(id, page, reqId, type, moreData) {
      if(reqId && reqId.includes('urn:li:msg_conversation') && page.network == 'linkedin') return
      // ind = this.list.findIndex(l => l._id == id)
      this.getEventMissingInfosFromRS(page.id, reqId, type, moreData).then((res) => {
        try {
          let ind = this.list.findIndex(l => l._id == id)
          if(ind === -1) return

          if (res && res.body && res.body.detail) {
            const isNotFound = Object.values(res.body.detail).some(v => v && typeof v === 'object' && (parseInt(v.status) === 404 || v.code === 'NOT_FOUND'))
            if (isNotFound) {
              this.changeEvent(id, { status: '4' })
              return
            }
          }

          if(this.selected?._id != id) return
          if(res && res.body && res.body.user) {
            this.$set(this.list[ind], 'user', res.body.user)
            this.$forceUpdate()
          }
          else if(res && res.body && res.body.detail) {
            this.$set(this.list[ind], 'detail', res.body.detail)
            if(page.network == 'linkedin') {
              this.$set(this.list[ind], 'user', res.body.detail.user)
            }
            else {
              if(res.body.detail.mentioned_comment) {
                this.list[ind].user = res.body.detail.mentioned_comment.from
                this.list[ind].data.changes.value.from = res.body.detail.mentioned_comment.from
                this.list[ind].data.changes.value.text = res.body.detail.mentioned_comment.text

              }else if(this.list[ind].data.changes.value.from) {
                this.list[ind].user = this.list[ind].data.changes.value.from
              }
              else if(res.body.detail.mentioned_media) {
                this.list[ind].user = {username: res.body.detail.mentioned_media.username}
                this.list[ind].data.changes.value.from = {username: res.body.detail.mentioned_media.username}
                this.list[ind].data.changes.value.text = res.body.detail.mentioned_media.caption
                this.list[ind].data.changes.value.media_url = res.body.detail.mentioned_media.media_url
              }
            }
            this.$forceUpdate()
          }
          else if(res && res.body && res.body.conversation && res.body.conversation.participants && res.body.conversation.participants.data) {
            this.list[ind].user = res.body.conversation.participants.data.find(p => p.id == this.list[ind].data.messaging.sender.id)
          }
        } catch (e) {
          console.error('updateEventMissingInfos failed for event', id, e)
        }
      })
    },

    hideEventsInbox(page) {
      this.list = this.list.filter(e => !(e.network == page.network && e.page == page.network_id))
      this.from[page.id] = {from: 0}  

      if(this.selected && this.selected.network == page.network && this.selected.page == page.network_id) 
        this.selected = this.list.length ? this.list[0] : null
    }

  },

  watch: {
    // async pages() {
    //   console.log('watch pages', this.pages.length)
    //   await this.getInbox()
    // }, 
    pages: {
      async handler(val, oldVal){
        // Premier chargement : on attend que "pages" soit réellement peuplé (le parent peut
        // encore être en train de le construire au tout premier rendu) plutôt que de lancer
        // getInbox() à l'aveugle depuis mounted().
        if(!this.initialInboxLoaded) {
          if(!val || !val.length) {
            this.isLoading = false
            return
          }
          this.initialInboxLoaded = true
          for(let p of val) this.from[p.id] = {from: 0}
          await this.getInbox({refresh: true})
          return
        }

        // let refresh = val.map(v => oldVal.find(o => o.id == v.id)).find(v => !v) || val.length != oldVal.length
        // if(refresh) await this.getInbox()

        const addedPages = val.filter(page => !oldVal.find(p => p.id === page.id))
        if(addedPages.length === 1) await this.getInbox({forcePage: addedPages[0]})
        else if(addedPages.length > 1) await this.getInbox({refresh: true})

        const removedPages = oldVal.filter(page => !val.find(p => p.id === page.id))
        if(removedPages.length) removedPages.map(page => this.hideEventsInbox(page))

        if(!val.length) {
          this.totalEvents = 0
          this.totalAllEvents = 0
        }

      },
      deep: true,
      immediate: true
    },
    ['filter.dateStart']() {
      this.filterIsModified = true
    },
    ['filter.dateEnd']() {
      this.filterIsModified = true
    },

    // filter: {
    //   async handler(val, oldVal){
    //     await this.getInbox()
    //     localStorage.setItem('inboxFilter', JSON.stringify(val))
    //   },
    //   deep: true
    // },

    selected() {
      this.closeFilter()
    }
  },

  beforeDestroy() {
    window.removeEventListener("click", this.handleClickOutsideFilter);
  },

}    
</script>